import { ReviewerTrackingDailyEntry } from "src/store/api/generatedApi";

export type ReviewerActionAggregate = Readonly<{
  totalActions: number;
  consumptionFalseNegatives: number;
  consumptionFalsePositives: number;
}>;

export const aggregateEntries = (
  entries: ReviewerTrackingDailyEntry[]
): ReviewerActionAggregate =>
  entries.reduce<ReviewerActionAggregate>(
    (accumulator, entry) => ({
      totalActions:
        accumulator.totalActions +
        entry.events_created +
        entry.events_deleted +
        entry.events_modified,
      consumptionFalseNegatives:
        accumulator.consumptionFalseNegatives +
        entry.consumption_events_created +
        entry.consumption_events_introduced,
      consumptionFalsePositives:
        accumulator.consumptionFalsePositives +
        entry.consumption_events_deleted +
        entry.consumption_events_removed,
    }),
    {
      totalActions: 0,
      consumptionFalseNegatives: 0,
      consumptionFalsePositives: 0,
    }
  );
